import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { selectPermissions } from '../../core/permissions/permission.selector';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor(private store: Store) {}

  /**
   * Checks if a module has any permissions (used for showing/hiding modules).
   */
  hasModulePermission(moduleId: number): Observable<boolean> {
    return this.store.select(selectPermissions).pipe(
      map(permissions => !!permissions[moduleId] && Object.keys(permissions[moduleId]).length > 0)
    );
  }

  /**
   * Checks if a specific permission exists for a module by description.
   * Example: hasPermission(ModuleIds.Employee, 'Create')
   */
  // hasPermission(moduleId: number, keyOrId: string | number): Observable<boolean> {
  // return this.store.select(selectPermissions).pipe(
  //   map(permissions => {
  //     console.log('permissions', permissions);
  //     console.log('moduleId ', moduleId);
  //     console.log('keyOrId ', keyOrId);
  //     const modulePerms = permissions[moduleId];
  //     console.log('modulePerms', modulePerms);
  //     // permissions.forEach((perm: any) =>{
  //     //   if(perm.description === keyOrId) {
  //     //     console.log('perm', perm);
  //     //     console.log('perm.keyOrId', perm[keyOrId]);
  //     //     return true;
  //     //   }
  //     // });
  //     if (!modulePerms) return false;

  //     if (typeof keyOrId === 'number') {
  //       // Handle old array style
  //       return Array.isArray(modulePerms) && modulePerms.includes(keyOrId);
  //     } else {
  //       // Handle new object style
  //       return !!modulePerms[keyOrId];
  //     }
  //   })
  // );
// }

hasPermission(moduleId: number, keyOrId: string | number): Observable<boolean> {
  return this.store.select(selectPermissions).pipe(
    map(permissions => {
      // const modulePerms = permissions[moduleId];
      console.log('permissions check', permissions);
      console.log('keyOrId', keyOrId);
      // if (!modulePerms) return false;

      // Ensure we always work with an array
      const permsArray = Array.isArray(permissions) ? permissions : [permissions];
      // if (typeof keyOrId === 'number') {
      //   // Handle old array style
      //   return Array.isArray(modulePerms) && modulePerms.includes(keyOrId);
      // } else {
      //   // Handle new object style
      //   return !!modulePerms[keyOrId];
      // }
        return permsArray.some((perm: any) => perm.description === keyOrId);
    })
  );
}
}
